import { Component, effect, inject } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { KEYCLOAK_EVENT_SIGNAL, KeycloakEventType } from 'keycloak-angular';
import { RouterTrackingService, UserTrackingService, WebVitalsService } from '@/shared/analytics';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule],
    template: `
        <router-outlet></router-outlet>`
})
export class AppComponent {
    private router = inject(Router);
    private event  = inject(KEYCLOAK_EVENT_SIGNAL);
    private routerTracking = inject(RouterTrackingService);
    private userTracking = inject(UserTrackingService);
    private webVitals = inject(WebVitalsService);

    constructor() {
        this.routerTracking.start();
        this.userTracking.start();
        void this.webVitals.start();

        effect(() => {
            const ev = this.event();

            // 1) Se deu um erro de autenticação (inclui timeout de iframe)
            if (ev.type === KeycloakEventType.AuthError) {
                this.router.navigate(['/auth/timeout']).then(() => {});
            }

            // 2) Se terminou de inicializar e NÃO está autenticado
            if (ev.type === KeycloakEventType.Ready && ev.args === false) {
                this.router.navigate(['/auth/timeout']).then(() => {});
            }
        });
    }
}
